import { render, staticRenderFns } from "./VideoUploadStep2.vue?vue&type=template&id=a0d3df3c&scoped=true&"
import script from "./VideoUploadStep2.vue?vue&type=script&lang=js&"
export * from "./VideoUploadStep2.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadStep2.vue?vue&type=style&index=0&id=a0d3df3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d3df3c",
  null
  
)

export default component.exports